import { useEffect } from 'react'
import { InsertTabs, SelectLayoutDrawer, CreateLayoutDrawer } from 'components'
import { useUpdatePageItems } from 'hooks'
import { useTranslation } from 'react-i18next'

export const SavedLayoutsMenu = ({
  setShow,
  basePages,
  baseLayout,
  setIsLoading,
  show,
}) => {
  const { t } = useTranslation()
  const { saveItems } = useUpdatePageItems()

  useEffect(() => {
    if (show) {
      const saveItemsAsync = async () => {
        // saveItems has logged its own failure; the drawer opens either way.
        await saveItems().catch(() => {})
      }
      saveItemsAsync()
    }
    //eslint-disable-next-line
  }, [show])

  return (
    <InsertTabs
      tabs={[
        {
          name: t('editor.menus.assets.savedLayouts.selectLayout'),
          content: () => (
            <SelectLayoutDrawer
              setShow={setShow}
              basePages={basePages}
              baseLayout={baseLayout}
              setIsLoading={setIsLoading}
            />
          ),
        },

        {
          name: t('editor.menus.assets.savedLayouts.saveNewLayout'),
          content: () => (
            <CreateLayoutDrawer setShow={setShow} basePages={basePages} />
          ),
        },
      ]}
    />
  )
}

export default SavedLayoutsMenu
